function randomBetween(min, max) {
	return Math.floor((Math.random() * (max - min)) + min);
}

function randomBoolean() {
	return Math.random() >= 0.5;
}

function randomBooleanPercent(precentage) {
	return Math.ceil(Math.random() * 100) <= precentage;
}

function randomIndex(array) {
	return randomBetween(0, array.length);
}

function randomIndexes(array, count) {
	const indexes = [];

	if (count > array.length) {
		return false;
	}

	while (indexes.length < count) {
		const index = randomIndex(array);

		if (indexes.indexOf(index) === -1) {
			indexes.push(index);
		}
	}

	return indexes;
}

function randomValue(array) {
	let value = null;

	if (Array.isArray(array)) {
		value = array[randomIndex(array)];
	} else {
		value = array[randomValue(Object.keys(array))];
	}

	return value;
}

function randomValues(array, count) {
	const values = [];
	const indexes = randomIndexes(array, count);

	indexes.forEach((index) => {
		values.push(array[index]);
	});

	return values;
}

export { randomBetween };
export { randomBoolean };
export { randomBooleanPercent };
export { randomIndex };
export { randomIndexes };
export { randomValue };
export { randomValues };

export default {
	methods: {
		randomBetween,
		randomBoolean,
		randomBooleanPercent,
		randomIndex,
		randomIndexes,
		randomValue,
		randomValues,
	},
};



// WEBPACK FOOTER //
// ./src/mixins/random.js